module.exports = __webpack_public_path__ + "staticcomp/img/content_1副本.f121cf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/4/content_1副本.jpg
// module id = lzTo
// module chunks = 39